export default {
  Purple: '#5524e0',
};
